// Vendors
import styled from 'styled-components';
import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const UploadIdSkeletonComponentContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${FoundationsCobrandedRegularTheme.spacing_250};
  width: 100%;
`;

UploadIdSkeletonComponentContainer.displayName = 'UploadIdSkeletonComponentContainer';

const ImageSkeleton = styled.section`
  display: flex;
  width: ${FoundationsCobrandedRegularTheme.size_900};
  height: ${FoundationsCobrandedRegularTheme.size_900};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  margin: 0 auto;
`;

ImageSkeleton.displayName = 'ImageSkeleton';

export { ImageSkeleton, UploadIdSkeletonComponentContainer };
